import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { detectScanner, SCANNER_STATE } from "@/lib/mantra";

const ScannerContext = createContext(null);

export function ScannerProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [status, setStatus] = useState({ state: SCANNER_STATE.NOT_FOUND, message: "Checking Mantra device…", mode: null, checking: true });

  const refresh = useCallback(async (s = settings) => {
    if (!s) return null;
    setStatus((p) => ({ ...p, checking: true }));
    const r = await detectScanner(s);
    const next = { ...r, checking: false, checkedAt: new Date().toISOString() };
    setStatus(next);
    return next;
  }, [settings]);

  useEffect(() => {
    api.get("/attendance/scanner-settings").then((r) => { setSettings(r.data); refresh(r.data); }).catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <ScannerContext.Provider value={{ settings, setSettings, status, setStatus, refresh }}>{children}</ScannerContext.Provider>;
}

export const useScanner = () => useContext(ScannerContext);
